import { EthereumService } from '../services/ethereum.service';

export function appInitializer(ethereumService: EthereumService): any {
  return () => {
    return new Promise(async (resolve) => {
      ethereumService.getCurrentETHPrice().subscribe();
      resolve(null);
    });
  };
}
